import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    if (window.innerWidth >= 1024) this.element.style.marginBottom = '468px'
  }
}
